module.exports = __webpack_public_path__ + "static/img/shanghai.9235e4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shanghai.jpg
// module id = MM2F
// module chunks = 0